export enum GapColumnDefs {
  LEFT_GAP = 'LEFT_GAP',
  RIGHT_GAP = 'RIGHT_GAP',
}
